import helpers from "./helpers";

const getErrorMessage = (response) => {
  let error = '';
  const { data } = response.data;
  const { getTranslationText } = helpers;

  //TODO: удалить это условие после рефакторинга добавления товара в коллекцию
  if (data?.errors && Object.keys(data.errors).length && Object.keys(data.errors)[0] === 'products.0') {
    return getTranslationText('collection.products_already_added') || 'One or more items from the list have already been added to the collection';
  }

  if (data) {
    if (data.errors) {
      // eslint-disable-next-line array-callback-return
      Object.keys(data.errors).map((key) => {
        if (key === 'message') {
          error += `${(error ? '\n\n' : '')}${data.errors[key]}`;
        } else {
          let message = '';
          if (Array.isArray(data.errors[key])) {
            message = data.errors[key].join('; ');
          } else {
            message = data.errors[key];
          }
          error += `${(error ? '\n\n' : '')}${key}: ${message}`;
        }
      });
    } else if (data.message) {
      error = data.message;
    }
  }
  return error || 'Error';
};

export default getErrorMessage;
